import React, { useEffect, useRef, useState } from "react";
import {
  applyBackgroundColor,
  applyLineSpacing,
  applyLetterSpacing,
  applyTextColor,
  applyWordSpacing,
} from "../../host/actions";
import OuterRangeSlider from "../outerRangerSlider";
import data from "../../data/data.ts";
import "../customize/customize.css";
import DisplayCard from "../displayCard";
import ColorPreview from "../colorPreview";
import ColorSlider from "../colorSlider/colorSlider";
import { setMoveWidget } from "../../reduxSlices/moveWidget";
import { setProfileData } from "../../reduxSlices/profile";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfileList,
  getWidgetPosition,
  getwidgetSize,
  setProfileList,
  setWidgetSize,
  setKeyboardStatus,
  isMobile,
  useKeyBoardShortcut,
  usePageStructureSync,
  useVoiceNavSync,
  setTooltipStatus,
  removeTooltipStatus,
  hideWidgetStatus,
  clearLocalStorageExceptHideWidgetStatus,
  setWidgetPosition,
  getColorSliderValues,
  setColorSliderValues,
} from "../../store/user";
import BlueLightFilter from "../blueLightFilter/blueLightFilter";
import useToggleWidget from "../../store/useToogleWidget";
import {
  setDictionaryActive,
  setVoiceNavigationActive,
} from "../../reduxSlices/booleanSlice";
import { selectIsResetOpen } from "../../reduxSlices/resetToggleSlice";
import { setKeyboardStatusRedux } from "../../reduxSlices/keyboardSlices";
import { useTranslation } from "react-i18next";
import { setHideInterfaceStatus } from "../../reduxSlices/hideInterfaceSlice";
import { getWidgetSettings } from "../../serivces/widgetService";

function AccessibilityCustomize({ color, selectedCategory, higlightId }) {
  const [isToggledWidgetBig, setIsToggledWidgetBig] = useState(false);
  const [isToggledContentAdjustment, setIsToggledContentAdjustment] =
    useState(false);
  const [isToggledColorAdjustment, setIsToggledColorAdjustment] =
    useState(false);
  const [isToggledOrientationAdjustment, setIsToggledOrientationAdjustment] =
    useState(false);
  const [isToggledMove, setIsToggledMove] = useState(false);
  const [isToggleHideInterface, setisToggleHideInterface] = useState(false);
  const [widgetSettings, setWidgetSettings] = useState(null);
  const [highlightedCardId, setHighlightedCardId] = useState(null);
  const [isRemoveButtonClicked, setIsRemoveButtonClicked] = useState(false);
  const [profile, setProfile] = useState([]);
  const [previewColors, setPreviewColors] = useState({
    backgroundColor: "#000000",
    textColor: "#ffffff",
  });

  const { closeWidget } = useToggleWidget();
  const isResetOpen = useSelector(selectIsResetOpen);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const contentAdjustmentRef = useRef(null);
  const colorAdjustmentRef = useRef(null);
  const orientationAdjustmentRef = useRef(null);

  const runAction = (action) => {
    if (typeof action === "function") {
      action();
    }
  };

  const createDefaultProfiles = () => {
    return data.profile.map((item) => ({
      ...item,
      items: Array.isArray(item.items)
        ? item.items.map((subItem) => ({ ...subItem }))
        : [],
      isSelected: false,
      currentCount: 0,
    }));
  };

  const findProfileByTitle = (profiles, title) => {
    return profiles.find((item) => item.title === title);
  };

  const normalizeFeatureKey = (str) => {
    return String(str || "")
      .replace(/\s+/g, "")
      .toLowerCase();
  };

  const toggleSwitchWidgetBig = () => {
    const nextValue = !isToggledWidgetBig;
    setIsToggledWidgetBig(nextValue);
    setWidgetSize(nextValue);
    document.documentElement.style.fontSize = nextValue ? "125%" : "100%";
  };

  const toggleHideWidget = () => {
    setisToggleHideInterface((prevState) => !prevState);
  };

  const handleHideInterface = () => {
    dispatch(setHideInterfaceStatus(true));
    setisToggleHideInterface(false);
    closeWidget();
    hideWidgetStatus(true);

    const sourceProfiles = profile.length > 0 ? profile : data.profile;

    for (let i = 0; i < sourceProfiles.length; i++) {
      runAction(sourceProfiles[i].unSelectedAction);
    }

    clearLocalStorageExceptHideWidgetStatus();
  };

  const toggleContentAdjustment = () => {
    setIsToggledContentAdjustment((prevState) => !prevState);
  };

  const toggleColorAdjustment = () => {
    setIsToggledColorAdjustment((prevState) => !prevState);
  };

  const toggleOrientationAdjustment = () => {
    setIsToggledOrientationAdjustment((prevState) => !prevState);
  };

  const toggleSwitchMove = () => {
    setIsToggledMove((prev) => {
      const nextValue = !prev;
      const position = nextValue ? "right" : "left";

      setWidgetPosition(position);
      dispatch(setMoveWidget(position));

      return nextValue;
    });
  };

  useEffect(() => {
    if (selectedCategory === "colorAdjustment") {
      setIsToggledColorAdjustment(true);
      setTimeout(() => {
        colorAdjustmentRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        if (higlightId) {
          setHighlightedCardId(higlightId);
          setTimeout(() => setHighlightedCardId(null), 2000);
        }
      }, 300);
    }

    if (selectedCategory === "orientationadjustments") {
      setIsToggledOrientationAdjustment(true);
      setTimeout(() => {
        orientationAdjustmentRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        if (higlightId) {
          setHighlightedCardId(higlightId);
          setTimeout(() => setHighlightedCardId(null), 2000);
        }
      }, 300);
    }

    if (selectedCategory === "contentAdjustment") {
      setIsToggledContentAdjustment(true);
      setTimeout(() => {
        contentAdjustmentRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        if (higlightId) {
          setHighlightedCardId(higlightId);
          setTimeout(() => setHighlightedCardId(null), 2000);
        }
      }, 300);
    }
  }, [selectedCategory, higlightId]);

  const handleSubItem = (id) => {
    const updatedProfiles = [...profile];

    for (let i = 0; i < updatedProfiles.length; i++) {
      if (
        updatedProfiles[i].profile === true &&
        updatedProfiles[i].customize === false
      ) {
        updatedProfiles[i].isSelected = false;

        if (updatedProfiles[i].title === "ADHD") {
          runAction(updatedProfiles[i].unSelectedAction);
        }
      }
    }

    for (let i = 0; i < updatedProfiles.length; i++) {
      if (updatedProfiles[i].id !== id) continue;

      const item = updatedProfiles[i];

      if (
        item.totalTapCount === 0 &&
        item.totalTapCount === item.currentCount
      ) {
        item.isSelected = !item.isSelected;

        if (item.isSelected === true) {
          if (item.title === "Voice Navigation") {
            runAction(item.action);
            closeWidget();
          } else if (item.title === "Dictionary") {
            dispatch(setDictionaryActive(true));
            const bigCursorItem = findProfileByTitle(
              updatedProfiles,
              "Big Cursor",
            );
            if (bigCursorItem && bigCursorItem.isSelected === false) {
              runAction(bigCursorItem.unSelectedAction);
            }
          } else if (item.title === "Page Structure") {
            const bigCursorItem = findProfileByTitle(
              updatedProfiles,
              "Big Cursor",
            );
            if (bigCursorItem && bigCursorItem.isSelected === false) {
              runAction(bigCursorItem.unSelectedAction);
            }
          } else if (item.title === "Keyboard Navigation") {
            setKeyboardStatus(true);
            dispatch(setKeyboardStatusRedux(true));
          } else if (item.title === "Tooltips") {
            setTooltipStatus(true);
          }
        } else {
          if (item.title === "Voice Navigation") {
            dispatch(setVoiceNavigationActive(false));
          } else if (item.title === "Dictionary") {
            dispatch(setDictionaryActive(false));
          } else if (item.title === "Keyboard Navigation") {
            setKeyboardStatus(false);
            dispatch(setKeyboardStatusRedux(false));
          } else if (item.title === "Tooltips") {
            removeTooltipStatus();
          }
        }
      } else {
        if (item.currentCount - 1 === item.totalTapCount) {
          item.isSelected = false;
          runAction(item.unSelectedAction);
          item.currentCount = 0;
        } else {
          item.isSelected = true;
          runAction(item.items?.[item.currentCount]?.subItemAction);
          item.currentCount++;
        }
      }
    }

    for (let i = 0; i < updatedProfiles.length; i++) {
      if (updatedProfiles[i].id !== id) continue;

      if (updatedProfiles[i].totalTapCount === 0) {
        if (updatedProfiles[i].isSelected === true) {
          runAction(updatedProfiles[i].action);
        } else {
          runAction(updatedProfiles[i].unSelectedAction);
        }
      }
    }

    setProfileList(updatedProfiles);
    setProfile(updatedProfiles);
    dispatch(setProfileData(updatedProfiles));
  };

  useEffect(() => {
    const storedData = getProfileList();

    if (storedData) {
      setProfile(storedData);

      for (let i = 0; i < storedData.length; i++) {
        if (storedData[i].isSelected === true) {
          if (storedData[i].totalTapCount > 0) {
            runAction(
              storedData[i].items?.[storedData[i].currentCount - 1]
                ?.subItemAction,
            );
          } else {
            runAction(storedData[i].action);
          }
        }
      }
    } else {
      setProfile(data.profile);
    }

    const widgetSize = getwidgetSize();
    setIsToggledWidgetBig(Boolean(widgetSize));
    document.documentElement.style.fontSize = widgetSize ? "125%" : "100%";

    getWidget();
    loadSavedColors();
  }, []);

  const getFunctionValue = (key) => {
    return widgetSettings?.advanced?.functions?.[key];
  };

  const loadSavedColors = () => {
    try {
      const stored = getColorSliderValues();
      const parsed = stored ? JSON.parse(stored) : {};

      setPreviewColors({
        backgroundColor: parsed?.backgroundColor || "#000000",
        textColor: parsed?.textColor || "#ffffff",
      });
    } catch (error) {
      console.error("Failed to load saved colors", error);
      setPreviewColors({
        backgroundColor: "#000000",
        textColor: "#ffffff",
      });
    }
  };

  const handlePreviewColorChange = (fieldName, nextColor) => {
    setPreviewColors((prev) => ({
      ...prev,
      [fieldName]: nextColor,
    }));
  };

  const getWidget = async () => {
    const injected = window.__INCLUWAY_BOOTSTRAP__;
    const resp = injected ?? (await getWidgetSettings());

    setWidgetSettings(resp);

    const storedPosition = getWidgetPosition();

    if (storedPosition === "right" || storedPosition === "left") {
      setIsToggledMove(storedPosition === "right");
      dispatch(setMoveWidget(storedPosition));
      return;
    }

    const settingsPosition =
      resp?.position?.positionOpen?.desktop?.horizontalAnchor;

    if (settingsPosition === "right" || settingsPosition === "left") {
      setIsToggledMove(settingsPosition === "right");
      dispatch(setMoveWidget(settingsPosition));
    }
  };

  useEffect(() => {
    if (!isResetOpen) return;

    for (let i = 0; i < profile.length; i++) {
      runAction(profile[i]?.unSelectedAction);
    }

    clearLocalStorageExceptHideWidgetStatus();

    applyBackgroundColor("");
    applyTextColor("");
    applyLetterSpacing(0);
    applyWordSpacing(0);
    applyLineSpacing(1.45);

    setColorSliderValues({
      backgroundColor: "",
      textColor: "",
    });

    const updatedProfiles = createDefaultProfiles();

    setProfile(updatedProfiles);
    setProfileList(updatedProfiles);
    dispatch(setProfileData(updatedProfiles));

    setKeyboardStatus(false);
    dispatch(setKeyboardStatusRedux(false));
    dispatch(setDictionaryActive(false));
    dispatch(setVoiceNavigationActive(false));
    removeTooltipStatus();

    setWidgetSize(false);
    document.documentElement.style.fontSize = "100%";
    setIsToggledWidgetBig(false);

    setPreviewColors({
      backgroundColor: "#000000",
      textColor: "#ffffff",
    });

    setIsRemoveButtonClicked((prev) => !prev);

    getWidget();
  }, [isResetOpen]);

  useKeyBoardShortcut(profile, setProfile, setProfileList);
  usePageStructureSync(profile, setProfile, setProfileList);
  useVoiceNavSync(profile, setProfile, setProfileList);

  return (
    <React.Fragment>
      <div className="flex flex-col items-center">
        {!isMobile() && widgetSettings?.advanced?.oversizedWidget === true && (
          <div className="w-[100%] h-[3rem] mt-[1rem] flex px-[1.5rem] border border-inner-widget-border rounded-[0.375rem] accordianBox">
            <div className="w-[50%] flex items-center gap-[2.06rem]">
              <div>
                <div
                  style={{ backgroundImage: `url(${"/innerWidget/XL.svg"})` }}
                  className="w-[1.75rem] h-[1.75rem] bg-no-repeat bg-center bg-contain"
                />
              </div>
              <div className="text-secondary font-[600] leading-[1.375rem] text-text-black text-nowrap">
                {t(data.customizeTabs[0].title)}
              </div>
            </div>
            <div className="w-[50%] flex items-center justify-end">
              <label
                className="toggle-container focus:outline-none focus:ring-2 focus:#3B4395 rounded-[5rem]"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleSwitchWidgetBig();
                  }
                }}
              >
                <input
                  type="checkbox"
                  checked={isToggledWidgetBig}
                  onChange={toggleSwitchWidgetBig}
                  className="sr-only"
                />
                <div
                  className={`toggle-switch toggle-switchBigWidget ${
                    isToggledWidgetBig ? "on" : ""
                  }`}
                  role="switch"
                  aria-checked={isToggledWidgetBig}
                />
              </label>
            </div>
          </div>
        )}

        <button
          className="w-[100%] h-[3rem] mt-[1rem] flex items-center justify-center px-[1.5rem] border border-inner-widget-border rounded-[0.375rem] cursor-pointer accordianBox"
          onClick={toggleContentAdjustment}
        >
          <div className="w-[100%] flex">
            <div className="w-[50%] flex items-center gap-[2.06rem]">
              <div className="text-nowrap text-secondary font-[600] leading-[1.375rem] text-text-black">
                {t(data.customizeTabs[1].title)}
              </div>
            </div>
            <div className="w-[50%] flex items-center justify-end">
              <div
                style={{
                  backgroundImage: `url('/widgetIcon/dropUp.svg')`,
                  transform: isToggledContentAdjustment
                    ? "rotate(0deg)"
                    : "rotate(180deg)",
                }}
                className="w-[1.875rem] h-[1.875rem] shrink-0 aspect-square transition-transform duration-300 ease-in-out bg-no-repeat bg-center bg-contain"
              />
            </div>
          </div>
        </button>

        {isToggledContentAdjustment && (
          <>
            <div
              ref={contentAdjustmentRef}
              className="flex transition-all duration-300 ease-in-out flex-wrap gap-[0.6rem] mt-[0.94rem] dropDownToggleContainer"
            >
              {(() => {
                let renderedCount = 0;

                return (
                  <>
                    {profile.map((item, index) => {
                      const isValid =
                        item.profile === false &&
                        item.customize === true &&
                        item.type === "contentAdjustment" &&
                        getFunctionValue(normalizeFeatureKey(item.title));

                      if (!isValid) return null;

                      renderedCount++;

                      return (
                        <div
                          key={index}
                          className="cursor-pointer"
                          onClick={() => {
                            if (!isMobile() || item.isMobileActive) {
                              if (
                                item.commingSoon === false ||
                                item.commingSoon === undefined
                              ) {
                                handleSubItem(item.id);
                              }
                            }
                          }}
                        >
                          <DisplayCard
                            color={color}
                            items={item}
                            isHighlighted={highlightedCardId === item.id}
                          />
                        </div>
                      );
                    })}

                    {isMobile() && renderedCount % 2 !== 0 && (
                      <div className="displayCardUnSelectedEmpty"></div>
                    )}
                  </>
                );
              })()}
            </div>

            <>
              {data.customizeFont.map((item, index) => {
                const key = Object.keys(item)[0];
                const value = item[key][0];
                return (
                  <OuterRangeSlider color={color} key={index} data={value} />
                );
              })}
            </>
          </>
        )}

        <button
          className="w-[100%] h-[3rem] mt-[1rem] flex px-[1.5rem] border border-inner-widget-border rounded-[0.375rem] cursor-pointer accordianBox"
          onClick={toggleColorAdjustment}
        >
          <div className="w-[100%] flex">
            <div className="w-[50%] flex items-center gap-[2.06rem]">
              <div className="text-nowrap text-secondary font-[600] leading-[1.375rem] text-text-black">
                {t(data.customizeTabs[2].title)}
              </div>
            </div>
            <div className="w-[50%] flex items-center justify-end">
              <div
                style={{
                  backgroundImage: `url('/widgetIcon/dropUp.svg')`,
                  transform: isToggledColorAdjustment
                    ? "rotate(0deg)"
                    : "rotate(180deg)",
                }}
                className="w-[1.875rem] h-[1.875rem] shrink-0 aspect-square transition-transform duration-300 ease-in-out bg-no-repeat bg-center bg-contain"
              />
            </div>
          </div>
        </button>

        {isToggledColorAdjustment && (
          <>
            <div ref={colorAdjustmentRef} className="flex justify-center">
              <div className="min-h-[2rem] w-[100%] flex transition-all duration-300 ease-in-out gap-[0.6rem] flex-wrap mt-[0.94rem] dropDownToggleContainer">
                {(() => {
                  let renderedCount = 0;

                  return (
                    <>
                      {profile.map((item, index) => {
                        const isValid =
                          item.profile === false &&
                          item.customize === true &&
                          item.type === "colorAdjustment" &&
                          getFunctionValue(normalizeFeatureKey(item.title));

                        if (!isValid) return null;

                        renderedCount++;

                        return (
                          <div
                            key={index}
                            className="cursor-pointer"
                            onClick={() => {
                              if (!isMobile() || item.isMobileActive) {
                                if (
                                  item.commingSoon === false ||
                                  item.commingSoon === undefined
                                ) {
                                  handleSubItem(item.id);
                                }
                              }
                            }}
                          >
                            <DisplayCard
                              color={color}
                              items={item}
                              isHighlighted={highlightedCardId === item.id}
                            />
                          </div>
                        );
                      })}

                      {isMobile() && renderedCount % 2 !== 0 && (
                        <div className="displayCardUnSelectedEmpty"></div>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>

            <div className="w-[100%] rounded-[0.75rem] border-[0.063rem] border-inner-widget-border mt-[0.94rem] px-[0.63rem] pb-[1rem]">
              {data.customizeColorData.map((item, index) => (
                <ColorSlider
                  key={index}
                  data={item}
                  value={
                    item.fieldName === "backgroundColor"
                      ? previewColors.backgroundColor
                      : previewColors.textColor
                  }
                  defaultValue={
                    item.fieldName === "backgroundColor" ? "#000000" : "#ffffff"
                  }
                  onChange={(nextColor) =>
                    handlePreviewColorChange(item.fieldName, nextColor)
                  }
                  isRemoveButtonClicked={isRemoveButtonClicked}
                />
              ))}
              <ColorPreview
                color={color}
                previewColors={previewColors}
                setPreviewColors={setPreviewColors}
                setIsRemoveButtonClicked={setIsRemoveButtonClicked}
                onApply={() => {
                  setColorSliderValues(previewColors);
                }}
              />
            </div>
          </>
        )}

        {/* <BlueLightFilter /> */}

        <button
          className="w-[100%] h-[3rem] mt-[1rem] flex px-[1.5rem] border border-inner-widget-border rounded-[0.375rem] cursor-pointer accordianBox"
          onClick={toggleOrientationAdjustment}
        >
          <div className="w-[100%] flex">
            <div className="w-[50%] flex items-center gap-[2.06rem]">
              <div className="text-nowrap text-secondary font-[600] leading-[1.375rem] text-text-black">
                {t(data.customizeTabs[3].title)}
              </div>
            </div>
            <div className="w-[50%] flex items-center justify-end">
              <div
                style={{
                  backgroundImage: `url('/widgetIcon/dropUp.svg')`,
                  transform: isToggledOrientationAdjustment
                    ? "rotate(0deg)"
                    : "rotate(180deg)",
                }}
                className="w-[1.875rem] h-[1.875rem] shrink-0 aspect-square transition-transform duration-300 ease-in-out bg-no-repeat bg-center bg-contain"
              />
            </div>
          </div>
        </button>

        {isToggledOrientationAdjustment && (
          <div
            ref={orientationAdjustmentRef}
            className="w-[100%] flex transition-all duration-300 ease-in-out gap-[0.6rem] flex-wrap mt-[0.94rem] dropDownToggleContainer"
          >
            {(() => {
              let renderedCount = 0;

              return (
                <>
                  {profile.map((item, index) => {
                    const isValid =
                      item.profile === false &&
                      item.customize === true &&
                      item.type === "orientationadjustments" &&
                      getFunctionValue(normalizeFeatureKey(item.title));

                    if (!isValid) return null;

                    renderedCount++;

                    return (
                      <div
                        key={index}
                        className="cursor-pointer"
                        onClick={() => {
                          if (!isMobile() || item.isMobileActive) {
                            if (
                              item.commingSoon === false ||
                              item.commingSoon === undefined
                            ) {
                              handleSubItem(item.id);
                            }
                          }
                        }}
                      >
                        <DisplayCard
                          color={color}
                          items={item}
                          isHighlighted={highlightedCardId === item.id}
                        />
                      </div>
                    );
                  })}

                  {isMobile() && renderedCount % 2 !== 0 && (
                    <div className="displayCardUnSelectedEmpty"></div>
                  )}
                </>
              );
            })()}
          </div>
        )}

        {!isMobile() && (
          <div className="w-[100%] h-[3rem] mt-[1rem] flex px-[1.5rem] border border-inner-widget-border rounded-[0.375rem] accordianBox">
            <div className="w-[50%] flex items-center gap-[2.06rem]">
              <div>
                <div
                  style={{
                    backgroundImage: `url(${"/customize/moveWidget.svg"})`,
                  }}
                  className="w-[1.75rem] h-[1.75rem] bg-no-repeat bg-center bg-contain"
                />
              </div>
              <div className="text-secondary font-[600] leading-[1.375rem] text-text-black text-nowrap">
                {t(data.customizeTabs[4].title)}
              </div>
            </div>
            <div className="w-[50%] flex items-center justify-end gap-[1.5rem]">
              <div className="text-secondary font-[600] leading-[1.375rem] text-text-black">
                {t("Left")}
              </div>
              <label
                className="toggle-container focus:outline-none focus:ring-2 focus:#3B4395 rounded-[5rem]"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleSwitchMove();
                  }
                }}
              >
                <input
                  type="checkbox"
                  checked={isToggledMove}
                  onChange={toggleSwitchMove}
                  className="sr-only"
                />
                <div
                  className={`toggle-switch ${isToggledMove ? "on" : ""}`}
                  role="switch"
                  aria-checked={isToggledMove}
                ></div>
              </label>

              <div className="text-secondary font-[600] leading-[1.375rem] text-text-black">
                {t("Right")}
              </div>
            </div>
          </div>
        )}

        <div className="w-[100%] h-[3rem] mt-[1rem] flex px-[1.5rem] border border-inner-widget-border rounded-[0.375rem] accordianBox">
          <div className="w-[50%] flex items-center gap-[2.06rem]">
            <div>
              <div
                style={{
                  backgroundImage: `url(${"/innerWidget/hideInterface.svg"})`,
                }}
                className="w-[1.75rem] h-[1.75rem] bg-no-repeat bg-center bg-contain"
              />
            </div>
            <div className="text-secondary font-[600] leading-[1.375rem] text-text-black text-nowrap">
              {t(data.customizeTabs[5].title)}
            </div>
          </div>
          <div className="w-[50%] flex items-center justify-end">
            <label
              className="toggle-container focus:outline-none focus:ring-2 focus:#3B4395 rounded-[5rem]"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  toggleHideWidget();
                }
              }}
            >
              <input
                type="checkbox"
                checked={isToggleHideInterface}
                onChange={toggleHideWidget}
                className="sr-only"
              />
              <div
                className={`toggle-switch toggle-switchBigWidget ${
                  isToggleHideInterface ? "on" : ""
                }`}
                role="switch"
                aria-checked={isToggleHideInterface}
              />
            </label>
          </div>
        </div>
      </div>

      {isToggleHideInterface && (
        <div className="bg-language-background w-[31.25rem] h-[95vh] z-[9999] absolute rounded-[0.75rem] top-0 left-0 flex items-center justify-center widgetContainerCustomize">
          <div className="bg-white w-[90%] max-w-[26rem] p-6 rounded-[0.75rem] shadow-lg flex flex-col gap-[1.5rem]">
            <div className="flex items-center justify-between">
              <div />
              <div className="text-[1rem] font-[700] text-text-black text-center leading-[1.375rem]">
                {t("Hide Accessibility Interface?")}
              </div>
              <button onClick={() => setisToggleHideInterface(false)}>
                <img
                  src="/language/closeBlack.svg"
                  alt="close"
                  className="w-[0.95rem] h-[0.95rem]"
                />
              </button>
            </div>

            <div className="text-[0.875rem] text-text-black leading-[1.25rem]">
              <span className="hidden md:inline">
                {t(
                  "The accessibility interface will be hidden and can only be restored using the shortcut ",
                )}
                <span className="font-[700] mx-[0.2rem]">{t("ALT+1")}</span>
                {t(
                  "or by clearing your browser data. Do you want to continue?",
                )}
              </span>

              <span className="inline md:hidden">
                {t(
                  "The accessibility interface will be hidden and can only be restored by clearing your browser data. Do you want to continue?",
                )}
              </span>
            </div>

            <div className="flex justify-between gap-[1rem]">
              <button
                onClick={handleHideInterface}
                className="flex-1 h-[2.5rem] rounded-[0.5rem] text-white font-medium hover:opacity-90"
                style={{
                  background: color.includes("linear-gradient")
                    ? color
                    : undefined,
                  backgroundColor: !color.includes("linear-gradient")
                    ? color
                    : undefined,
                }}
              >
                {t("Hide")}
              </button>
              <button
                onClick={() => setisToggleHideInterface(false)}
                className="flex-1 h-[2.5rem] rounded-[0.5rem] border border-[#1212121A] text-[#121212] font-medium hover:bg-gray-100"
              >
                {t("Cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default AccessibilityCustomize;
